import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Select, Divider, Drawer,
} from 'antd';
import SellerActions from '@Actions/sellerActions';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import VendorForm from '@Components/Common/VendorForm';

import './style.scss';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
class SelectSellerId extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  /**
   *
   * @param props
   * @param state
   * @return {(*&)|*}
   */
  static getDerivedStateFromProps(props, state) {
    const { getSellers, user } = props;
    const { isUserReady } = state;
    if (user?.tenant_info?.tenant_id && !isUserReady) {
      getSellers('', user?.tenant_info?.tenant_id, 1, 1000, '', () => {}, true);
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      sellers, onChange, selectedSellerId, disabled, showError, title, hideTitle, containerClass, inputClassName, labelClassName,
      getSellers, user, showAddVendor, getPopupContainer, customStyle, notRequired, dropdownAlign,
    } = this.props;
    const { showNewVendorModal } = this.state;
    return (
      <div className={`${containerClass} select-vendor__wrapper` || 'orgInputContainer select-vendor__wrapper'}>
        <Drawer
          open={showNewVendorModal}
          onClose={() => this.setState({ showNewVendorModal: false })}
          width="720px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '680px' }}>
              <H3Text text="Add New Vendor" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showNewVendorModal: false })} />
            </div>
          </div>
          <VendorForm
            callback={(createdSeller) => {
              getSellers('', user?.tenant_info?.tenant_id, 1, 1000, '', (newSellers) => {
                onChange(newSellers?.sellers.filter((seller) => seller?.seller_id === createdSeller.seller_id)[0]);
                this.setState({ showNewVendorModal: false });
              }, true);
            }}
          />
        </Drawer>
        {!hideTitle ? (
          <div className={labelClassName || 'orgFormLabel'}>
            {title || 'Select Vendor'}
            {!notRequired && <span style={{ color: 'red' }}>{'  *'}</span>}
          </div>
        ) : <label /> }
        <div className={inputClassName || 'orgFormInput input'}>

          <PRZSelect
            value={selectedSellerId}
            dropdownAlign={{ offset: [3, 8] }}
            filterOption={false}
            getPopupContainer={getPopupContainer ? (triggerNode) => triggerNode.parentNode : false}
            placeholder="Select vendor.."
            disabled={disabled}
            onChange={(value) => onChange(sellers?.sellers.filter((seller) => seller?.seller_id === value)[0])}
            style={customStyle || {
              height: '28px',
              width: '100%',
            }}
            showSearch
            onSelect={() => {
              getSellers('', user?.tenant_info?.tenant_id, 1, 1000, '', () => {}, true);
            }}
            onSearch={(value) => {
              getSellers(value, user?.tenant_info?.tenant_id, 1, 1000, '', () => {}, true);
            }}
            dropdownRender={
              showAddVendor ? (menu) => (
                <React.Fragment>
                  {menu}
                  <Divider style={{ margin: '0px' }} />
                  <div className="add__vendor" onClick={() => this.setState({ showNewVendorModal: true })}>
                    + Add Vendor
                  </div>
                </React.Fragment>
              ) : false
            }
            showError={showError}
            errorName="*Please select vendor"
            errorClassName="input-error"
          >
            {sellers && sellers.sellers && sellers.sellers
              .map((item) => (
                <Option key={item.seller_id} value={item.seller_id}>
                  {`${item?.seller_info?.seller_name }${item?.seller_info?.office_address_details ? ` (${ item?.seller_info?.office_address_details?.city})` : ''}`}
                </Option>
              ))}
          </PRZSelect>
        </div>
      </div>

    );
  }
}

const mapStateToProps = ({ SellerReducers, UserReducers }) => ({
  getCustomersLoading: SellerReducers.getCustomersLoading,
  sellers: SellerReducers.sellers,
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
  getSellers: (keyword, tenantId, page, limit, sellerId, callback, isActive) => dispatch(
    SellerActions.getSellers(keyword, tenantId, page, limit, sellerId, callback, isActive),
  ),
});

SelectSellerId.propTypes = {
  user: PropTypes.any,
  sellers: PropTypes.any,
  selectedSellerId: PropTypes.any,
  getSellers: PropTypes.func,
  showAddVendor: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  containerClass: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.string,
  getPopupContainer: PropTypes.bool,
  customStyle: PropTypes.any,
  dropdownAlign: PropTypes.any,
  notRequired: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectSellerId));
